import { Stack, Typography } from '@ui-components/neo.tax';
import LaptopImg from '@ui-components/neo.tax/dist/images/computer-soft-cap-projects.svg?url';

import { PayrollProvider, TicketingProvider } from '@neo.tax/shared/graphql';

import { ProviderLogo } from '../provider-logo';
import {
  StyledConfidence1,
  StyledConfidence2,
  StyledConfidence3,
  StyledConfidenceText,
  StyledImageContainer,
  StyledInfoColumn,
  StyledLaptopColumn,
  StyledLaptopImage,
} from './analysis-info.styled';
import { AnalysisFeatureGroup } from './AnalysisFeatureGroup';

const LOGO_SIZE = 21;

export const AnalysisInfo = (): React.ReactElement => {
  const features = [
    {
      title: 'Connect Data',
      id: 'connectDataFeature',
      subtitle: 'Link your project management system so NeoTax can analyze all the tickets your company worked on.',
      children: (
        <Stack gap={2}>
          <ProviderLogo provider={TicketingProvider.JiraCloud} size={LOGO_SIZE} />
          <ProviderLogo provider={TicketingProvider.GithubIssues} size={LOGO_SIZE} />
        </Stack>
      ),
    },
    {
      title: 'Confirm Projects',
      id: 'confirmProjectFeature',
      subtitle:
        "NeoTax automatically identifies your company's projects from the project management data. All you have to do is confirm and adjust if needed.",
      children: (
        <Stack gap={2}>
          <ProviderLogo provider={PayrollProvider.Gusto} size={LOGO_SIZE} />
          <ProviderLogo provider={PayrollProvider.Rippling} size={LOGO_SIZE} />
          <ProviderLogo provider={PayrollProvider.Trinet} size={LOGO_SIZE} />
          <ProviderLogo provider={PayrollProvider.AdpRun} size={LOGO_SIZE} />
        </Stack>
      ),
    },
    {
      title: 'Review Effort',
      id: 'reviewEffortFeature',
      subtitle:
        'NeoTax automatically calculates the effort each engineer spent on each project based on the tickets. Review effort for the period and make edits if necessary.',
      children: (
        <Stack gap={2}>
          <Stack direction="column">
            <StyledConfidence1 />
            <StyledConfidenceText fontSize="sm" lineHeight={5} color="secondary">
              Research
            </StyledConfidenceText>
          </Stack>
          <Stack direction="column">
            <StyledConfidence2 />
            <StyledConfidenceText fontSize="sm" lineHeight={5}>
              Develop
            </StyledConfidenceText>
          </Stack>
          <Stack direction="column">
            <StyledConfidence3 />
            <StyledConfidenceText fontSize="sm" lineHeight={5}>
              Maintain
            </StyledConfidenceText>
          </Stack>
        </Stack>
      ),
    },
  ];
  return (
    <Stack gap={8} alignItems="start" justifyContent="center">
      <StyledInfoColumn direction="column" gap={10}>
        <Stack direction="column" gap={3}>
          <Typography as="h2" fontSize="3xl" fontWeight="extrabold" lineHeight={9}>
            Automated Projects & Effort
          </Typography>
          <Typography as="p" fontSize="lg" lineHeight={7}>
            NeoTax takes care of the data gathering for you. NeoTax automatically identifies the projects your company
            worked on and how much time they spent from your project management data. All you have to do is review and
            export.
          </Typography>
        </Stack>
        <Stack direction="column" gap={10}>
          <AnalysisFeatureGroup features={features} />
        </Stack>
      </StyledInfoColumn>
      <StyledLaptopColumn alignItems="center" justifyContent="center">
        <StyledImageContainer>
          <StyledLaptopImage src={LaptopImg} />
        </StyledImageContainer>
      </StyledLaptopColumn>
    </Stack>
  );
};
